/*
Field photographs: parallax inside a fixed frame.
Why: gives the two images depth without moving anything the reader is reading.
If it is noticeable as an effect, it is too strong.
*/

export function field(gsap) {
  const frames = gsap.utils.toArray('.field__frame');

  if (!frames.length) return;

  frames.forEach((frame) => {
    const image = frame.querySelector('img');
    if (!image) return;

    gsap.fromTo(image, { yPercent: -8 }, {
      yPercent: 8,
      ease: 'none',
      scrollTrigger: { trigger: frame, start: 'top bottom', end: 'bottom top', scrub: true },
    });
  });
}
